import React from "react";
import { BoxIcon } from "lucide-react";
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  body: string;
  action?: React.ReactNode;
}
export function EmptyState({
  icon: Icon,
  title,
  body,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center px-6 py-14 text-center" data-id="element-306" data-mp="136n5ju59b5lp">
      <span className="flex h-10 w-10 items-center justify-center rounded-full border border-line bg-canvas" data-id="element-307" data-mp="y57la4awl34d">
        <Icon className="h-4 w-4 text-ink-soft" aria-hidden="true" data-id="element-308" data-mp="1c4fjouz8s77i" />
      </span>
      <h3 className="mt-4 text-sm font-semibold text-ink" data-id="element-309" data-mp="175vxquknevf5">{title}</h3>
      <p className="mt-1.5 max-w-sm text-[13px] leading-relaxed text-ink-muted" data-id="element-310" data-mp="1lvjx3q99rk08">
        {body}
      </p>
      {action && <div className="mt-5" data-id="element-311" data-mp="1gwgra3lgt9r7">{action}</div>}
    </div>;
}